/*
  【SH】カラーバリエーション: 色を押した瞬間に反応させる（ページ遷移そのものは通常の <a href>）
  出力元: templates/product.json の custom_liquid ブロック sh_color_variation ／ 仕様: GitHub issue #25
*/
(function () {
  if (window.__colorSiblingsReady) return;
  window.__colorSiblingsReady = true;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('.color-siblings a.color-siblings__item');
    if (!link) return;
    var nav = link.closest('.color-siblings');
    nav.classList.add('is-navigating');
    link.classList.add('is-loading');
    var current = nav.querySelector('.color-siblings__current');
    if (current && link.title) current.textContent = link.title;
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('.color-siblings.is-navigating').forEach(function (nav) {
      nav.classList.remove('is-navigating');
      nav.querySelectorAll('.is-loading').forEach(function (el) {
        el.classList.remove('is-loading');
      });
      var here = nav.querySelector('.color-siblings__item.is-current');
      var current = nav.querySelector('.color-siblings__current');
      if (here && current && here.title) current.textContent = here.title;
    });
  });
})();
